var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerFull"},[_c('SlideImages'),_c('HorizontalInfoCircles'),_c('GaleriaMain'),_c('Kpis'),_c('MediosDePago'),_c('ComoSerParte'),_c('Blog'),_c('TestimonialesSlider'),_c('Convenios')],1)}
var staticRenderFns = []

export { render, staticRenderFns }